package com.gsb.vyapar.bhagya.util

import co.touchlab.kermit.Logger
import com.gsb.vyapar.bhagya.domain.getAbout
import com.gsb.vyapar.bhagya.domain.getAndroid
import com.gsb.vyapar.bhagya.domain.getEmail
import com.gsb.vyapar.bhagya.domain.getFb
import com.gsb.vyapar.bhagya.domain.getInst
import com.gsb.vyapar.bhagya.domain.getIos
import com.gsb.vyapar.bhagya.domain.getMobile
import com.gsb.vyapar.bhagya.domain.getPrivacy
import com.gsb.vyapar.bhagya.domain.getShare
import com.gsb.vyapar.bhagya.domain.getSupport
import com.gsb.vyapar.bhagya.domain.getTerms
import com.gsb.vyapar.bhagya.domain.getUpi
import com.gsb.vyapar.bhagya.domain.getWebApp
import com.gsb.vyapar.bhagya.domain.getWebsite
import com.gsb.vyapar.bhagya.domain.getX
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import io.ktor.http.encodeURLParameter
import kotlin.random.Random
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

fun Throwable?.getMessage(): String {
    return this?.message?.let {
        return it
    }?: run {
        return "UnKnown Error"
    }
}

fun Int?.getString(): String {
    return this?.let { this.toString() }?: run { "" }
}

fun canShowRateUs(): Boolean {
    return BuildConfig.userAgent() != PlatformType.DESKTOP
}

fun getRateUsUrl(): String {
    return if (BuildConfig.userAgent() == PlatformType.ANDROID) {
        getState().getInfo().getAndroid()
    } else if (BuildConfig.userAgent() == PlatformType.IOS) {
        getState().getInfo().getIos()
    } else {
        getState().getInfo().getWebsite()
    }
}

fun getPrivacyUrl(): String {
    return getState().getInfo().getPrivacy()
}

fun getTermsUrl(): String {
    return getState().getInfo().getTerms()
}

fun getAbout(): String {
    return getState().getInfo().getAbout()
}

fun getSupport(): String {
    return getState().getInfo().getSupport()
}

fun getUpi(): String {
    return getState().getInfo().getUpi()
}

fun getAndroid(): String {
    return getState().getInfo().getAndroid()
}

fun getIos(): String {
    return getState().getInfo().getIos()
}

fun getWebApp(): String {
    return getState().getInfo().getWebApp()
}

fun getX(): String {
    return getState().getInfo().getX()
}

fun getFb(): String {
    return getState().getInfo().getFb()
}

fun getInst(): String {
    return getState().getInfo().getInst()
}

fun getEmail(): String {
    return getState().getInfo().getEmail()
}

fun getMobile(): String {
    return getState().getInfo().getMobile()
}

fun getWebsite(): String {
    return getState().getInfo().getWebsite()
}

fun getShare(): String {
    return getState().getInfo().getShare()
}

fun getRandomIntString(): String {
    return Random.nextInt(100000, 999999).toString()
}

@OptIn(ExperimentalTime::class)
fun getPresentTimeString(): String {
    return Clock.System.now().epochSeconds.toString()
}

fun getMapUrl(latitude: String, longitude: String): String {
    return when (BuildConfig.platform()) {
        PlatformType.ANDROID -> "geo:$latitude,$longitude?q=$latitude,$longitude"
        PlatformType.DESKTOP -> "https://www.google.com/maps?q=$latitude,$longitude"
        PlatformType.IOS -> "https://maps.apple.com/?q=$latitude,$longitude"
        PlatformType.JS -> when (BuildConfig.userAgent()) {
            PlatformType.ANDROID -> "https://www.google.com/maps?q=$latitude,$longitude"
            PlatformType.DESKTOP -> "https://www.google.com/maps?q=$latitude,$longitude"
            PlatformType.IOS -> "http://maps.apple.com/?q=$latitude,$longitude"
            PlatformType.JS -> "https://www.google.com/maps?q=$latitude,$longitude"
            PlatformType.WASM -> "https://www.google.com/maps?q=$latitude,$longitude"
        }
        PlatformType.WASM -> when (BuildConfig.userAgent()) {
            PlatformType.ANDROID -> "https://www.google.com/maps?q=$latitude,$longitude"
            PlatformType.DESKTOP -> "https://www.google.com/maps?q=$latitude,$longitude"
            PlatformType.IOS -> "http://maps.apple.com/?q=$latitude,$longitude"
            PlatformType.JS -> "https://www.google.com/maps?q=$latitude,$longitude"
            PlatformType.WASM -> "https://www.google.com/maps?q=$latitude,$longitude"
        }
    }
}

fun getBusinessIdFromUrl(url: String?): String? {
    if (url.isNullOrBlank()) return null
    val queryStart = url.indexOf('?')
    if (queryStart == -1 || queryStart == url.length - 1) return null
    val queryString = url.substring(queryStart + 1)
    val params = queryString.split("&").mapNotNull {
        val parts = it.split("=")
        if (parts.size == 2) parts[0] to parts[1] else null
    }.toMap()
    return params["business"]
}

fun getEncodedMessage(message: String): String {
    return message.encodeURLParameter()
}

fun gvbLog(message: String) {
    if (BuildConfig.isDebug()) Logger.d(message)
}